const reportsPageData = {
    header : {
        image : {
            src : "reports.jpg",
            alt : "",
        }
    },
    title : "Reports",
    paragraphOne : "SAB is committed to providing our stakeholders with access to detailed information regarding our ESG performance, initiatives, and progress. Our ESG reporting follows globally recognized standards, enabling stakeholders to gain insights into our efforts to mitigate environmental risks, enhance social impact, and strengthen our governance practices. We recognize the importance of effectively communicating our ESG commitments and performance to stakeholders and ensure our reporting practices align with the evolving landscape of ESG disclosures.",
};

export default reportsPageData;